import React, { useEffect, useState } from 'react'
import AccordionTwo from '../Accordion/AccordionTwo'
import { Link, useSearchParams } from 'react-router-dom';
import Input from '../Form Elements/Input';

function CategoryMinifFlter({ utilities, onCLick }) {

    const [values, setValues] = useState({ min_price: 0, max_price: 0 });

    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();

    // Handle Price Filter 


    useEffect(() => {
        setValues({ ...values, max_price: utilities?.maxPriceProduct?.base_price })
    },
        // eslint-disable-next-line
        [utilities?.maxPriceProduct]
    )


    const priceFilter = () => {
        if (!values.max_price) {
            return
        }
        searchParams.set("min_price", values.min_price)
        searchParams.set("max_price", values.max_price)
        setSearchParams(searchParams)
    }


    return (
        <div className='px-5'>
            {/* Category */}
            <AccordionTwo title="Category" open>
                {utilities && utilities?.categories && utilities?.categories?.length > 0 && (
                    <ul className="w-full mt-2 flex flex-col gap-3">
                        {utilities?.categories?.map((category, i) => (
                            <Link
                                onClick={() => onCLick()}
                                key={i}
                                to={`/product-category/${category?.name?.toLowerCase()}`}
                                className='text-gray-500'
                            >
                                {category?.name}
                            </Link>
                        ))}
                    </ul>
                )}
            </AccordionTwo>

            {/* Price */}
            <AccordionTwo title="Price" open>
                <div className="w-full">
                    <div className='py-5 flex gap-2 items-center'>
                        <div className='space-y-1'>
                            <p className='font-medium'>From:</p>
                            <Input no_rounded style={{ padding: "10px 8px" }} value={values.min_price}
                                type='number'
                                onChange={(e) => {
                                    setValues({ ...values, min_price: e.target.value })
                                }}
                            />
                        </div>
                        <div className='space-y-1'>
                            <p className='font-medium'>To:</p>
                            <Input no_rounded style={{ padding: "10px 8px" }}
                                type='number'
                                value={values.max_price}
                                onChange={(e) => {
                                    setValues({ ...values, max_price: e.target.value })
                                }}
                            />
                        </div>
                    </div>

                    {/* Filter btn */}
                    <button
                        className='text-sm bg-black p-2 px-3 rounded-lg text-white'
                        onClick={priceFilter}
                    >
                        Apply Filter
                    </button>
                </div>
            </AccordionTwo>

        </div>
    )
}

export default CategoryMinifFlter